import React, { useState } from 'react';
import { VideoTestimonials } from '../shared/VideoTestimonials';
export const VideoTestimonialsSection = () => {
  const [playingVideo, setPlayingVideo] = useState<string | null>(null);
  const videos = [{
    id: 'video-1',
    posterUrl: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1eea06fe59cfd08c9cab77_Untitled%20design%20(6).png',
    title: 'More than doubled my salary',
    quote: "I frickin' more than doubled my salary. I didn't believe in coaching, but David's the real deal.",
    videoUrl: 'https://youtube.com/shorts/ZfiItKCjvvU?feature=share'
  }, {
    id: 'video-7',
    posterUrl: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1eea07d6f40d2705eda3e2_Untitled%20design%20(1).png',
    title: 'My salary skyrocketed',
    quote: 'I went from being in a startup to $20k increase at Gusto',
    videoUrl: 'https://youtube.com/shorts/IscMg5x1768?feature=share'
  }, {
    id: 'video-2',
    posterUrl: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1eea07516e64a966082384_Untitled%20design%20(8).png',
    title: '3 offers all in 1 week',
    quote: 'Six weeks after joining Platinum, I had 5 interviews in progress. Three offers. One dream job.',
    videoUrl: 'https://youtube.com/shorts/5jSv8QcH2hg?feature=share'
  }, {
    id: 'video-3',
    posterUrl: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1eea096e7e9727caab3979_untitled%20design%203.png',
    title: 'Apple shocked me with their offer.',
    quote: "Apple wasn't even on my radar. The recruiter was surprised no one in the chain of command rejected the $742,000 offer they advocated for me.",
    videoUrl: 'https://youtube.com/shorts/jpVLAocxTgA?feature=share'
  }, {
    id: 'video-4',
    posterUrl: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1eea080b58f03de52f30b2_Untitled%20design%204.png',
    title: 'Storytelling & Negotiation > Leetcode',
    quote: 'I thought it was just going to be a grind through endless Leetcode, but the support in crafting my narrative was what made the difference.',
    videoUrl: 'https://youtube.com/shorts/t4KD_IB9pDA?feature=share'
  }, {
    id: 'video-5',
    posterUrl: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1eea09b05920c810b971f7_Untitled%20design%20(5).png',
    title: 'Got a raise after a 4 year break',
    quote: 'I was on a career break for 4 years. I got an offer with a raise, and I thought I was going to have to take a pay cut.',
    videoUrl: 'https://youtube.com/shorts/jFGZRTFDgB0?feature=share'
  }, {
    id: 'video-6',
    posterUrl: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1eea078a6c8d77f865b555_Untitled%20design%20(7).png',
    title: 'Coaching and Executive Dysfunction',
    quote: 'If you\'re struggling with executive function like many neurodivergent people, coaching can really help keep the momentum going.',
    videoUrl: 'https://youtube.com/shorts/g4UJIlskEmo?feature=share'
  }];
  const handlePlay = (video: (typeof videos)[0]) => {
    // For YouTube videos, open in a new tab
    if (video.videoUrl && (video.videoUrl.includes('youtube.com') || video.videoUrl.includes('tiktok.com') || video.videoUrl.includes('instagram.com'))) {
      window.open(video.videoUrl, '_blank');
    } else {
      setPlayingVideo(video.id);
    }
  };
  const currentVideo = playingVideo ? videos.find(v => v.id === playingVideo) : null;
  return <>
      <VideoTestimonials items={videos} onPlay={handlePlay} data-id="element-327" />
      {/* Video Modal */}
      {playingVideo && currentVideo && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setPlayingVideo(null)} data-id="element-328">
          <div className="relative w-full max-w-4xl aspect-video" data-id="element-329">
            <iframe src={currentVideo.videoUrl} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-330" />
            <button className="mt-4 px-4 py-2 bg-white/10 text-white rounded" onClick={() => setPlayingVideo(null)} data-id="element-331">
              Close
            </button>
          </div>
        </div>}
    </>;
};